import * as React from "react";
function SvgVerified(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M32 16a6 6 0 00-3.28-5.33A6.09 6.09 0 0029 9a6 6 0 00-6-6 5.75 5.75 0 00-1.7.27A6 6 0 0013.18.69a5.93 5.93 0 00-2.54 2.54A6.09 6.09 0 009 3a6 6 0 00-6 6 6.09 6.09 0 00.27 1.69A6 6 0 00.66 18.8a6.1 6.1 0 002.54 2.54A5.93 5.93 0 009 29a5.75 5.75 0 001.7-.27 6 6 0 0010.66 0 5.94 5.94 0 007.44-7.44A6 6 0 0032 16z" />
      <path
        fill="#fff"
        d="M23.06 13l-8 8a1.49 1.49 0 01-2.12 0l-4-4a1.5 1.5 0 012.12-2.12L14 17.86l6.94-6.94A1.5 1.5 0 0123.06 13z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVerified);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
